import { render, staticRenderFns } from "./CreateAppointmentButton.vue?vue&type=template&id=2c5c65cc&scoped=true&"
import script from "./CreateAppointmentButton.vue?vue&type=script&lang=ts&"
export * from "./CreateAppointmentButton.vue?vue&type=script&lang=ts&"
import style0 from "./CreateAppointmentButton.vue?vue&type=style&index=0&id=2c5c65cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5c65cc",
  null
  
)

export default component.exports